import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {GuardConfig} from "@/modules/redactor/models/guard/GuardConfig";

export class AdUnitModel extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._guard = new GuardConfig();

        this._placements = [];

        this._cooldown = 0;
        this._dailyLimit = 0;
        this._sessionLimit = 0;
        this._sessionDuration = 0;

        this._adUnitIOS = null;
        this._adUnitAndroid = null;
        this._adUnitAmazon = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get placements() {
        return this._placements;
    }

    set placements(value) {
        this._placements = value;
    }

    get cooldown() {
        return this._cooldown;
    }

    set cooldown(value) {
        this._cooldown = value;
    }

    get dailyLimit() {
        return this._dailyLimit;
    }

    set dailyLimit(value) {
        this._dailyLimit = value;
    }

    get sessionLimit() {
        return this._sessionLimit;
    }

    set sessionLimit(value) {
        this._sessionLimit = value;
    }

    get sessionDuration() {
        return this._sessionDuration;
    }

    set sessionDuration(value) {
        this._sessionDuration = value;
    }

    get adUnitIOS() {
        return this._adUnitIOS;
    }

    set adUnitIOS(value) {
        this._adUnitIOS = value;
    }

    get adUnitAmazon() {
        return this._adUnitAmazon;
    }

    set adUnitAmazon(value) {
        this._adUnitAmazon = value;
    }

    get adUnitAndroid() {
        return this._adUnitAndroid;
    }

    set adUnitAndroid(value) {
        this._adUnitAndroid = value;
    }

    valid() {

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (!this.placements || this.placements.length <= 0) {
            return false;
        }

        if (!this.adUnitIOS || this.adUnitIOS.length <= 0) {
            return false;
        }

        if (!this.adUnitAmazon || this.adUnitAmazon.length <= 0) {
            return false;
        }

        if (!this.adUnitAndroid || this.adUnitAndroid.length <= 0) {
            return false;
        }

        if (!Number.isInteger(this.cooldown) || this.cooldown < 0) {
            return false;
        }

        if (!Number.isInteger(this.dailyLimit) || this.dailyLimit < 0) {
            return false;
        }

        if (!Number.isInteger(this.sessionLimit) || this.sessionLimit < 0) {
            return false;
        }

        if (!Number.isInteger(this.sessionDuration) || this.sessionDuration < 0) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new AdUnitModel());
        } else if (target instanceof AdUnitModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(AdUnitModel, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _guard: alias("guard", GuardConfig.schema()),
    _placements: alias("placements", list(Schema.primitive())),
    _cooldown: alias("cooldown", Schema.primitive()),
    _dailyLimit: alias("daily_limit", Schema.primitive()),
    _sessionLimit: alias("session_limit", Schema.primitive()),
    _sessionDuration: alias("session_duration", Schema.primitive()),

    _adUnitIOS: alias("ad_unit_ios", Schema.primitive()),
    _adUnitAmazon: alias("ad_unit_amazon", Schema.primitive()),
    _adUnitAndroid: alias("ad_unit_android", Schema.primitive())
});